import { ExternalLink } from "lucide-react";
import { useI18n } from "../context/I18nContext";
import { Overline, Reveal } from "./Reveal";

const SAZON_URL =
  "https://sazonthefolkcook.com/en/experiences/edu/romantic-dining-with-alhambra-views-in-granadas-historic-albayzin";

export default function SazonSection() {
  const { t } = useI18n();

  return (
    <section data-testid="sazon-section" className="bg-olivelight py-20 text-charcoal">
      <div className="mx-auto grid max-w-7xl items-center gap-8 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <Overline>{t.sazon.overline}</Overline>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-5 font-serif text-3xl leading-tight md:text-4xl">{t.sazon.title}</h2>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.14}>
            <p className="leading-relaxed text-charcoal/70">{t.sazon.text}</p>
            <a
              data-testid="sazon-profile-button"
              href={SAZON_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2.5 rounded-full bg-charcoal px-7 py-3.5 text-sm font-medium text-cream transition-all duration-300 hover:scale-[1.02] hover:bg-terra"
            >
              {t.sazon.cta}
              <ExternalLink size={15} />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
